<template>
  <div>
    <div class="login-page h-screen bg-cover bg-center">
      <div class="container h-full">
        <div class="row items-center h-full">
          <section
            class="_col mx-auto bg-white container_login px-16 flex align-middle items-center"
          >
            <div class="w-full">
              <div class="login-page__logo py-5 text-red">
                <div class="ondealte_icon text-center mx-auto block my-6">
                  <OndeAlte />
                </div>
                <VPLogo class="m-auto" />
              </div>

              <div
                class="login-page__button py-5 text-center"
                v-if="!showForms"
              >
                <button class="btn-default" @click="showForms = true">
                  Accedi
                </button>
              </div>

              <div class="login-page__forms py-5" v-show="showForms">
                <template v-if="!formForgotPassword">
                  <FormLogin @forgotPassword="formForgotPassword = $event" />
                </template>
                <template v-else>
                  <FormForgotPassword
                    @forgotPassword="formForgotPassword = $event"
                  />
                </template>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Components */
import FormLogin from '@/components/FormLogin.vue'
import FormForgotPassword from '@/components/FormForgotPassword.vue'
import VPLogo from '@/assets/images/VP-Logo.svg'
import OndeAlte from '@/assets/icons/ondealte.svg'

export default {
  components: {
    FormLogin,
    FormForgotPassword,
    VPLogo,
    OndeAlte,
  },

  data() {
    return {
      showForms: false,
      formForgotPassword: false,
    }
  },
}
</script>
<style>
.ondealte_icon svg {
  fill: #000;
  display: inline-block;
}

.container_login {
  max-width: 600px;
  min-height: 450px;
  min-width: 570px;
}

.login-page {
  background-image: url('/background.jpg');
}
</style>
